<select #voorbeeldSelectie (change)="selecteerVoorbeeldtekst(voorbeeldSelectie.value)" *ngIf="bezwaarEntity.submissionDate === undefined"
        class="form-select mb-3"
        style="width: 25%">
  <option value="">-- Gebruik een voorbeeldtekst --</option>
  <option *ngFor="let tekst of gefilterdeVoorbeeldTeksten" [value]="tekst.value">
    {{ tekst.label }}
  </option>
</select>

<form [formGroup]="formGroup">
  <snelstart-ui-textarea-form-control (change)="saveForm()"
                                      [rows]="20"
                                      class="me-1 custom-input-800"
                                      formControlName="motivatie"
                                      id="motivatie"
                                      placeholder="Schrijf hier de motivatie van het bezwaar">

  </snelstart-ui-textarea-form-control>
</form>

